import { useEffect, useState } from "react";
import { Button, Offcanvas } from "react-bootstrap";
import Navtoggle from "../assets/images/nav-toggle.svg";
import "./Header.css";
import logo from "../assets/images/lyra-logo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";

function Header() {
  const location = useLocation();
  const isActive = (path) => {
    return location.pathname === path;
  };
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        // Adjust threshold (e.g., 10px)
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const navigate = useNavigate();
  return (
    <div className={`header ${isScrolled ? "scrolled" : ""}`}>
      <div className="container">
        <div
          className={`row align-items-center justify-content-between navbar ${isScrolled ? "nav-scrolled" : ""}`}
        >
          <div className="col-lg-2 col-md-3 col-5">
            <Link to="/">
              {" "}
              <img src={logo} alt="Lyra Logo" className="header-logo" />
            </Link>
          </div>
          <div className="col-7 d-none d-lg-block">
            <ul className="d-flex  align-items-center justify-content-center m-0 p-0">
              <li>
                <Link
                  to="/"
                  className={`nav-link ${isActive("/") ? "active" : ""}`}
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className={`nav-link ${isActive("/about") ? "active" : ""}`}
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className={`nav-link ${isActive("/services") ? "active" : ""}`}
                >
                  Products
                </Link>
              </li>
              <li>
                <Link
                  to="/careers"
                  className={`nav-link ${isActive("/careers") ? "active" : ""}`}
                >
                  Careers
                </Link>
              </li>
              {/* <li><Link to="/contact" className="nav-link">Contact Us</Link></li> */}
              <Button
                className="btn nav-btn"
                onClick={() => {
                  navigate("/contact");
                }}
              >
                <span> Contact Us</span>
              </Button>
            </ul>
          </div>

          <div className="col-2 col-md-1 d-lg-none d-flex flex-column  navbar">
            <img
              src={Navtoggle}
              alt="Menu Icon"
              onClick={handleShow}
              style={{ cursor: "pointer", height: "25px" }}
            />
          </div>

          <Offcanvas show={show} onHide={handleClose}>
            <Offcanvas.Header closeButton>
              <Offcanvas.Title></Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <ul className="d-flex flex-column justify-content-between m-0 p-0">
                <li>
                  <Link
                    to="/"
                    className={`nav-link ${isActive("/") ? "active" : ""}`}
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className={`nav-link ${isActive("/about") ? "active" : ""}`}
                  >
                    About Us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/services"
                    className={`nav-link ${isActive("/services") ? "active" : ""}`}
                  >
                    Services
                  </Link>
                </li>
                <li>
                  <Link
                    to="/careers"
                    className={`nav-link ${isActive("/careers") ? "active" : ""}`}
                  >
                    Careers
                  </Link>
                </li>
                {/* <li>
                  <Link to="/contact" className="nav-link">
                    Contact Us
                  </Link>
                </li> */}
                <Button
                  className="btn nav-btn"
                  onClick={() => {
                    navigate("/contact");
                  }}
                >
                  <span> Contact Us</span>
                </Button>
              </ul>
            </Offcanvas.Body>
          </Offcanvas>
        </div>
      </div>
    </div>
  );
}

export default Header;
